// extracted by mini-css-extract-plugin
export default {"container":"BenefitsSection_container__mtczk","carouselContainer":"BenefitsSection_carouselContainer__0YgHU","cardContainer":"BenefitsSection_cardContainer__bGlHy"};